import {text_mod_15, } from "../text/Text.js";
export const module15 = {
  title:
    "§15. Створюю кілька речень на добре відому тему",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_15, },
    ]
  }
